import { API_HOST_NAME } from "../../constants.js"
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js"

const useInterfacesResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/networking/interfaces`
  return useAuthenticatedResources(url)
}

export default useInterfacesResources
